
import { createGesture } from '@ionic/core'
import {
  IonCol,
  IonGrid,
  IonRow,
  IonButtons,
  IonButton,
  IonIcon,
  GestureDetail,
} from '@ionic/vue'
import { caretForwardOutline, caretBackOutline } from 'ionicons/icons'
import { onMounted, defineComponent, PropType, ref } from 'vue'
import { Dayjs } from 'dayjs'
import { useCalendarBaseModule } from '@/provider/CalendarBaseModule'

export default defineComponent({
  components: {
    IonCol,
    IonGrid,
    IonRow,
    IonButtons,
    IonButton,
    IonIcon,
  },
  props: {
    setModalDate: {
      type: Function as PropType<(date: Dayjs | null) => void>,
      required: true,
    },
  },
  setup(props) {
    const movingHandler = ref(false)
    const {
      isCurrentMonthToday,
      setCurrentMonthPrev,
      setCurrentMonthCurrent,
      setCurrentMonthNext,
      loading,
      calendarPages,
      calendarDateList,
    } = useCalendarBaseModule()
    onMounted(() => {
      const onMoveHandler = (ev: GestureDetail) => {
        if (movingHandler.value || Math.abs(ev.velocityX) <= 1) return
        movingHandler.value = true
        if (ev.deltaX > 0) {
          setCurrentMonthPrev()
        } else if (ev.deltaX < 0) {
          setCurrentMonthNext()
        }
      }
      const el = document.getElementById('calendar-grid-swiper')
      if (!el) return
      const gesture = createGesture({
        el,
        threshold: 40,
        gestureName: 'my-gesture',
        onMove: (ev) => onMoveHandler(ev),
        onEnd: () => (movingHandler.value = false),
      })
      gesture.enable()
    })

    const clickCalendarPage = (date: Dayjs) => {
      props.setModalDate(date)
    }
    return {
      isCurrentMonthToday,
      loading,
      calendarPages,
      clickCalendarPage,
      calendarDateList,
      setCurrentMonthPrev,
      setCurrentMonthCurrent,
      setCurrentMonthNext,
      caretForwardOutline,
      caretBackOutline,
    }
  },
})
